import TableAHSF from "../../Components/TableAHSF"
import PopupAHSF from "../../Components/PopupAHSF"
import './style.css'
import Swal from "sweetalert2"
import { useDispatch, useSelector } from "react-redux"
import AddStages from "./AddStages"
import { useParams } from "react-router-dom"
import { useEffect, useState } from "react"
import { decryptToken } from "../../Services/Account/EncryptionParams"
import { DeleteReportsStages, GetLengthReportsStages } from "../../Redux/Reducers/ReportStage/Stages"
import { setRefreshTable } from "../../Redux/Reducers/VariousVariables"
import { encryptToken } from "../../Services/Account/EncryptionParams";
import { useNavigate } from "react-router-dom";

const ReportStages = (props) => {
    const navigate=useNavigate()

    const dispatch = useDispatch()
    const tokens = useParams().token
    const [appGuid, setAppGuid] = useState(null)
    const lengthReportsStages = useSelector((state) => state.Stages.LengthReportsStages)
    const deleteStage = useSelector((state) => state.Stages.deletReportsStages)
    const addStagesActionRefresh = useSelector((state) => state.Stages.AddStages)

    console.log(lengthReportsStages, "slkdlksdsdsdsd");

    useEffect(() => {


        if (tokens) {
            var token = decryptToken(tokens)
            setAppGuid(token)
            // console.log(token,"sdkjskijdsiiisd");

        }

    }, [])


    useEffect(() => {
        dispatch(GetLengthReportsStages({ aI_ApplicationInformationId: appGuid }))
    }, [appGuid, addStagesActionRefresh, deleteStage])
    const state = useSelector((state) => {
        return {
            jsonData: state.FetchDataJson.JsonData,
            ActiveRound: state.ApplicationInformation.ActiveRound,
            ApplicationInformation:
                state.ApplicationInformation.ApplicationInformation,
        };
    });
    const culomEdite = ["email", "fullName"];
    const staticKeyEdite = ["userGUID", "ssoguid", "lastUpdate"];
    const RequestsColumns = [];

    const RequestAccessor = [
        {
            KeyName: "stagesName",
            ShowStatus: true,
            NmaeColumn: "المرحلة",
            TotalNumber: true,
            DropdownFiltration: { keyTextName: "", keyValueName: "" },
            DropdownFiltrationStatus: false,
            GroupOfColumns: false


        },
        {
            KeyName: "startMonth",
            ShowStatus: true,
            NmaeColumn: "شهر البداية",
            TotalNumber: true,
            DropdownFiltration: { keyTextName: "", keyValueName: "" },
            DropdownFiltrationStatus: false,
            GroupOfColumns: false


        },
        {
            KeyName: "endMonth",
            ShowStatus: true,
            NmaeColumn: "شهر النهاية",
            TotalNumber: true,
            DropdownFiltration: { keyTextName: "", keyValueName: "" },
            DropdownFiltrationStatus: false,
            GroupOfColumns: false


        },
        {
            KeyName: "implementationDurartion",
            ShowStatus: true,
            NmaeColumn: "مدة التنفيذ",
            TotalNumber: true,
            DropdownFiltration: { keyTextName: "", keyValueName: "" },
            DropdownFiltrationStatus: false,
            GroupOfColumns: false


        },
        {
            KeyName: "statusStagesName",
            ShowStatus: props.view == true ? true : false,
            NmaeColumn: "حالة المرحلة",
            TotalNumber: true,
            DropdownFiltration: { keyTextName: "", keyValueName: "" },
            DropdownFiltrationStatus: false,
            GroupOfColumns: false


        },
    ];
    const OtherBtnsView = [
        {
            Click: async (e) => {
                navigate(`/grants/manager/ReportStageContainerManager/${encryptToken(e.target.value)}`);
            },
            content: "",
            className: "bi bi-view-list",
            id: "editBtn",
            title: "عرض",
            ShowStatus: true,
        }
    ]
    const OtherMainBtns = [


        {
            Click: async (e) => {
                Swal.fire({
                    title: state.jsonData.deleteTitlePopUp?.nameAR,
                    icon: "error",
                    // iconHtml: "؟",
                    confirmButtonText: "تأكيد",
                    cancelButtonText: "الغاء",
                    showCancelButton: true,
                    showCloseButton: true,
                }).then((res) => {
                    dispatch(DeleteReportsStages({ pR_ReportsStagesGuid: e.target.value }))
                    if (res.isConfirmed == true) {
                        Swal.fire({
                            position: "center",
                            icon: "success",
                            title: "تم الحذف بنجاح",
                            showConfirmButton: false,
                            timer: 1500,
                            // width: "500px",
                        });

                    }
                });
            },
            content: "",
            className: "bi bi-trash",
            id: "deleteBtn",
            title: "حذف",
            ShowStatus: true,
        },

    ];
    const PopupOPjectData = {
        isPopupOpenStatus: true,
        isPopupOpenFunction: () => { },
        componentBody: <AddStages appGuid={appGuid} />,
        maxWidth: "500px",
        maxHeight: "800px",
        title: "مراحل التقرير",
    };


    useEffect(() => {
        dispatch(setRefreshTable())
    }, [deleteStage])
    console.log(addStagesActionRefresh, "sdsdsdawwwwww");

    useEffect(() => {
        dispatch(setRefreshTable())
    }, [addStagesActionRefresh])
    return (
        <>

            <TableAHSF
                culomEdite={culomEdite}
                uniqueValue={"pR_ReportsStagesGuid"}
                valueButtonAction={"pR_ReportsStagesGuid"}
                URL={`api/PR_ReportsStages/GetListReportsStagesByApplicationInformationGUID`}
                UrlBody={{
                    aI_ApplicationInformationId: props.view == true ? props.applicationInformationGuid : appGuid,
                }}
                staticKeyEdite={staticKeyEdite}
                accessor={RequestAccessor}
                titelTable={""}
                selectRowNumber={true}
                checkBoksColumName="اختيار"
                sort={true}
                pagination={true}
                AppStatus={true}
                lengthReportsStages={lengthReportsStages}
                lastButton={props.view == true ? false : true}
                tableBtn={props.view ? false : true}
                sortTable={true}
                keyNameSort={"dateCreate"}
                dateKey="dateCreate"
                dateformat="DD/MM/YYYY h:mm a"
                arrayNameSort={["applicationNumber"]}
                search={true}
                openPopupState={false}
                DropdownArrayFiltration={[]}
                DropdownFiltration={false}
                exportData={true}
                checkBoks={false}
                nameColumAction=""
                total={false}
                arrayButton={props.view == true ? OtherBtnsView : OtherMainBtns}
                ArrayNameDataColum={RequestsColumns}
                columnKeyNameArray={[
                    { keyName: "applicationNumber", nameColimn: " رقم الطلب" },
                ]}
                PopupOPjectData={PopupOPjectData}
                popUpTitle={"معلومات الطلب"}

            />
            <PopupAHSF
                title={"الأهداف"}
                componentBody={
                    <></>
                }
                maxWidth="700px"
                maxHeight="800px"
                isPopupOpenStatus={false}
                isPopupOpenFunction={false}
            />

            <PopupAHSF
                title={"الأهداف"}
                componentBody={
                    <></>

                }
                maxWidth="700px"
                maxHeight="800px"
                isPopupOpenStatus={false}
                isPopupOpenFunction={false}
            />

        </>
    )
}

export default ReportStages